var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.375V2.75h1.375v4.125a2.75 2.75 0 1 1-5.5 0V2.75h1.375V1.375H11v5.5a4.128 4.128 0 0 0 3.438 4.063v4.187a4.125 4.125 0 0 1-8.25 0v-4.223a2.75 2.75 0 1 0-1.375 0v4.223a5.5 5.5 0 0 0 11 0v-4.187a4.129 4.129 0 0 0 3.437-4.063v-5.5H16.5zM4.125 8.25a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctorIcon.3b13d098e46ef314ff5dfe4c76546eaa.svg";
export { ForwardRef as ReactComponent };